import * as React from "react";
import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import Autocomplete from "@material-ui/lab/Autocomplete";

export interface Props {
  options: string[];
  value: string;
  placeholder?: string;
  onChange: (value: string) => void;
  isLoading?: boolean;
  autoFocus?: boolean;
  isRequired?: boolean;
}

export function EditableSelect({
  options,
  value,
  onChange,
  placeholder,
  isLoading = false,
  autoFocus = false,
  isRequired = false,
}: Props) {
  return (
    <Autocomplete
      freeSolo
      options={options}
      inputValue={value}
      onInputChange={(_, newInputValue, reason) => {
        if (reason === "input") {
          onChange(newInputValue);
        }
      }}
      onChange={(_, newValue) => {
        onChange(typeof newValue === "string" ? newValue : "");
      }}
      filterOptions={(x) => x}
      clearOnBlur={false}
      selectOnFocus={false}
      handleHomeEndKeys
      fullWidth
      popupIcon={null}
      forcePopupIcon={false}
      loading={isLoading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={placeholder}
          required={isRequired}
          autoFocus={autoFocus}
          fullWidth
          variant="outlined"
          InputLabelProps={{
            ...params.InputLabelProps,
            shrink: Boolean(value),
          }}
          inputProps={{
            ...params.inputProps,
            style: {
              fontSize: "16px",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
          }}
          InputProps={{
            ...params.InputProps,
            style: {
              borderRadius: 4,
              minHeight: 40,
            },
            endAdornment: (
              <>
                {isLoading ? (
                  <CircularProgress color="inherit" size={16} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}